import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";

import NoAccessPage from "components/AccessPage/NoAccessPage";
import JobCardProductionRejectionDetailListAdd from "./JobCardProductionRejectionDetailListAdd";
import JobCardRejectionRecycleAdd from "./JobCardRejectionRecycle/JobCardRejectionRecycleAdd";

const tabItems = [
  { label: "Rework & Return", value: "Rework" },
  { label: "Recycle", value: "Recycle" },
];

function JobCardProductionRejectionDeailsTopTab() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [activeTab, setActiveTab] = useState();
  const { id } = useParams();
  const childRef = React.useRef(null);

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const name = sessionStorage.getItem("name");

  useEffect(() => {
    setActiveTab(
      sessionStorage.getItem("tab") == "Rework"
        ? "Rework"
        : sessionStorage.getItem("tab")
    );
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };

  return (
    <>
      {erplist.some((item) => item.erp_module_id == 4 && item.view) ? (
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {
            setIsModalOpen(false);
            navigate(-1);
          }}
          ariaHideApp={false}
          style={{
            content: { width: "90%", height: "85%", margin: "auto" },
            overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
          }}
        >
          <div className="w-full flex flex-col">
            <div className="flex items-center justify-between">
              <div className="flex gap-2">
                {tabItems.map((t) => (
                  <button
                    key={t.value}
                    onClick={() => handleTabClick(t.value)}
                    className={`px-4 py-2 rounded-t ${
                      activeTab === t.value
                        ? "bg-white-A700 border-t border-l border-r border-gray-300 font-semibold text-blue-500"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {t.label}
                  </button>
                ))}
              </div>

              <div>
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                    navigate(-1);
                  }}
                  className="text-xl font-bold px-3 py-1"
                >
                  ╳
                </button>
              </div>
            </div>

            <div className="mt-4 border p-4 bg-white-A700">
              {activeTab === "Rework" && (
                <JobCardProductionRejectionDetailListAdd
                  id={id}
                  item_name={name}
                  ref={childRef}
                />
              )}
              {activeTab === "Recycle" && (
                <JobCardRejectionRecycleAdd
                  id={id}
                  item_name={name}
                  ref={childRef}
                />
              )}
            </div>
          </div>
        </Modal>
      ) : (
        <NoAccessPage />
      )}
    </>
  );
}

export default JobCardProductionRejectionDeailsTopTab;
